import { connect } from 'react-redux';
import {
  MID_GET_INDEX_MINICART,
} from '@js/constants/middlewareActionsTypes';

import HeaderContainer from '@js/commonComponents/HeaderContainer';

const mapStateToProps = (state) => {
  const { miniCartData } = state.cartState;

  return {
    miniCartData,
  };
};

const mapDispatchToProps = (dispatch) => ({
  // header部 mini購物車
  getIndexMiniCart: (payload) => dispatch({ type: MID_GET_INDEX_MINICART, payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(HeaderContainer);
